module.exports = __webpack_public_path__ + "static/media/Bahia Simons-Lane Headshot_1621433828078.ffc744f7.jpeg";